import { useEffect } from "react";
import useCurrencies from "api/CurrencyResource/useCurrencies";
import usePaymentMethodAvailability from "api/PaymentsResource/usePaymentMethodAvailability";
import useCurrencyStore from "store/currencyStore";
import { registerCurrencies } from "utils";

export default function CurrencyBootstrap() {
    const { data: currencies } = useCurrencies();
    const { data: methods } = usePaymentMethodAvailability();
    const { setCatalog, setMethods } = useCurrencyStore();
    useEffect(() => {
        if (currencies) { registerCurrencies(currencies); setCatalog(currencies); }
    }, [currencies, setCatalog]);
    useEffect(() => { if (methods) setMethods(methods); }, [methods, setMethods]);
    return null;
}
